/*
 *   Copyright (c) 2025 Luxembourg Institute of Science and Technology
 *   All rights reserved.
 */
import * as React from "react"
import { Tooltip } from "antd"
import { QuestionCircleOutlined } from "@ant-design/icons"

interface LabelWithTooltipProps {
  label: string
  tooltip: string
  iconStyle?: React.CSSProperties
}

const LabelWithTooltip: React.FC<LabelWithTooltipProps> = ({
  label,
  tooltip,
  iconStyle = { cursor: "help", fontSize: "0.85em", verticalAlign: "super" },
}) => (
  <>
    {label}{" "}
    <Tooltip title={tooltip}>
      <QuestionCircleOutlined style={iconStyle} />
    </Tooltip>
  </>
)

export default React.memo(LabelWithTooltip)
